import { getAuth, onAuthStateChanged, type User } from 'firebase/auth';

import { generateSpanId, Trace } from '@gitbook/util-debug';

let currentUserId: string | null = null;

/**
 * Pass the user ID and session ID to all traces sent to the backend.
 */
export function autoStartLogSession() {
    const onUser = (user: User | null) => {
        if (user && user.uid !== currentUserId) {
            currentUserId = user.uid;

            const sessionId = generateSpanId();

            Trace.setGlobalState({
                userId: currentUserId,
                sessionId,
            });
        }
    };

    const auth = getAuth();
    onAuthStateChanged(auth, onUser);
    onUser(auth.currentUser);
}
